const RESULT_COLOUR = {
  assigned: "text-teal-600", worker_already_assigned: "text-amber-600",
  assigned_with_issues: "text-amber-700",
  worker_on_leave: "text-red-600", no_matching_shift: "text-red-600", blocked: "text-red-600",
};

export function ResultRows({ results, prefix }) {
  return results.map((r, i) => (
    <tr key={i} className="border-b border-slate-100 align-top" data-testid={`${prefix}-row-${i}`}>
      <td className="px-3 py-1.5 whitespace-nowrap text-slate-600">{r.date} <span className="text-slate-400">({r.day})</span></td>
      <td className="px-2 py-1.5 whitespace-nowrap text-slate-500">{r.start}–{r.end}</td>
      <td className="px-2 py-1.5 text-slate-700 truncate">{r.worker_name || "—"}</td>
      <td className={`px-2 py-1.5 font-medium ${RESULT_COLOUR[r.status] || "text-slate-500"}`}>
        {r.status === "blocked" && <span className="inline-block px-1.5 py-0.5 mr-1 rounded bg-red-100 text-red-700 text-[9px] font-bold uppercase">Blocked</span>}
        {r.status === "assigned_with_issues" && <span className="inline-block px-1.5 py-0.5 mr-1 rounded bg-amber-100 text-amber-800 text-[9px] font-bold uppercase" data-testid={`${prefix}-flagged-${i}`}>Assigned · flagged</span>}
        {r.reason}
        {(r.warnings || []).length > 0 && (
          <div className="text-amber-600 text-[10px] mt-0.5">⚠ {r.warnings.map((w) => w.message).join("; ")}</div>
        )}
      </td>
      <td className="px-3 py-1.5 whitespace-nowrap">{r.shift_name ? <span className="font-mono text-brand">{r.shift_name}</span> : <span className="text-slate-300">—</span>}</td>
    </tr>
  ));
}
